<div class="modal-header">
  <h4 class="modal-title"><strong>Internship Opportunities at Visual Media Lab</strong></h4>
</div>

<div class="modal-body">
  <p>
    We welcome passionate and creative individuals to join us as interns.
  </p>
  <p>
    <strong>Application:</strong><br>
    Applications are open on a rolling basis.<br>
    Selected candidates will be contacted individually for interviews.<br>
    To apply, please submit your application(with a CV) to 
    <a href="mailto:visualmedia@kaist.ac.kr" style="color:blue; text-decoration:underline;">
      visualmedia@kaist.ac.kr
    </a>.
  </p>
</div>

<div class="modal-footer">
  <button class="modal-button" (click)="closeModal()">Close</button>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/shared/popup-modal/popup-modal.component.html